Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Federated", {
    enumerable: true,
    get: function() {
        return _federated.Federated;
    }
});
var _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./ScriptManager.js"), exports);
_export_star._(require("./Script.js"), exports);
_export_star._(require("./types.js"), exports);
_export_star._(require("./getWebpackContext.js"), exports);
var _federated = require("./federated.js");
